import request from 'sb-request'
import { reducers } from 'redux/core'


const reset = () => reducers.view.zodiacSignPage.reset()

const fetchProducts = (gender, zodiacSign) => {
  reducers.view.zodiacSignPage.setFetchStatus(true)

  return request.post('graphql?name=products', {
    body: {
      query: `{
        products(gender: "${gender}", zodiacs: ["${zodiacSign}"]) {
          id
          img
          url
          sex
          type
          name
          brand
          rating
          labels
          category
          upchargePrice
        }
      }`,
    },
  })
    .then(({ products }) => {
      reducers.view.zodiacSignPage.setProducts(products)
    })
}

export default {
  fetchProducts,
  reset,
}
